(() => {
  window.addEventListener('fpt-matching', (e) => {
    let matching_id = e.detail.matching_id;
    if (matching_id) {
      // set cart attribute
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'fpt_matching_id': matching_id
          }
        })
      });
    }
  });
})();